import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Current Year Totals',
  attributeName: 'annual-view',
  fields: [
    {
      attributeName: 'yeartotal',
      type: FormInputTypes.TEXT,
      placeholder: 'Content name',
      label: 'Total Amount',
      errorText: '',
      canEdit:false,
    },
    {
      attributeName: 'numtickets',
      type: FormInputTypes.TEXT,
      label: 'Num Tickets used',
      errorText: '',
      canEdit:false,
    },
  ],
};
